export const overrideData = {
  outDoorJumpSpots: [
    '68d1318e208f82c724e18089',
    '68d23c51208f82c724e1b8e3',
    '68d11fb3f1fff2aa8e505189',
    '68d11ff8f1fff2aa8e505326',
    '68d12016f1fff2aa8e50534e',
    '68d12769ddcbe92b6b39ad9e',
  ],

  inDoorJumpSpots: [
    '68f0bf7b4ac102ae931ebab4',
    '68e78ba6fa4f187e528e4525',
    '68e78c15fa4f187e528e458f',
    '68e78cc2fa4f187e528e4661',
    '68e78c4efa4f187e528e45ea',
    '68e78c75fa4f187e528e461c',
  ],

  amenitiesScenes: [
    '690b2e80fbeb572cfafcfaf6',
    '690b2fd1fbeb572cfafcfc34',
    '690b2e51fbeb572cfafcfac5',
    '690b2f34fbeb572cfafcfb85',
    '690b2ebafbeb572cfafcfb24',
  ],

  sceneFlycamOutdoorSpots: [
    '68d12cca208f82c724e17eb7',
    '68d12e81208f82c724e18004',
  ],
  apartmentSpots: [
    '68e78ba6fa4f187e528e4525',
    '68e78c15fa4f187e528e458f',
    '68e78c4efa4f187e528e45ea',
    '68e78c75fa4f187e528e461c',
    '68e78cc2fa4f187e528e4661',
  ],

  sceneTitle: [
    {
      sceneId: '68d12cca208f82c724e17eb7',
      title: 'Tổng quan 1',
      coordinates: [0.15, 0.45],
    },
    {
      sceneId: '68d12e81208f82c724e18004',
      title: 'Tổng quan 2',
      coordinates: [0.8, 0.35],
    },
    {
      sceneId: '68d1318e208f82c724e18089',
      title: 'Tầng 5',
      coordinates: [0.6, 0.35],
    },
    {
      sceneId: '68d23c51208f82c724e1b8e3',
      title: 'Tầng 10',
      coordinates: [0.6, 0.35],
    },
    {
      sceneId: '68d11fb3f1fff2aa8e505189',
      title: 'Tầng 15',
      coordinates: [0.6, 0.35],
    },
    {
      sceneId: '68d11ff8f1fff2aa8e505326',
      title: 'Tầng 20',
      coordinates: [0.6, 0.35],
    },
    {
      sceneId: '68d12016f1fff2aa8e50534e',
      title: 'Tầng 25',
      coordinates: [0.6, 0.35],
    },
    {
      sceneId: '68d12769ddcbe92b6b39ad9e',
      title: 'Tầng 30',
      coordinates: [0.6, 0.35],
    },
  ],
};

export const applyOverrideData = (json) => {
  if (!json || !Array.isArray(json.scenes)) return;

  const {
    outDoorJumpSpots,
    sceneFlycamOutdoorSpots,
    sceneTitle,
    apartmentSpots,
    amenitiesScenes,
    inDoorJumpSpots,
  } = overrideData;

  // Inject MapFloorPlan (amenities.webp) for all scenes
  const AMENITIES_IMAGE_URL = '/assets/images/map/amenities.webp';

  const upsertAmenitiesFloorPlanHotspot = (scene) => {
    const hotspotList = Array.isArray(scene.hotspots) ? scene.hotspots : [];
    const existingIndex = hotspotList.findIndex(
      (h) => h.type === 'MapFloorPlan'
    );

    // Convert sceneTitle entries with coordinates to objects format for mapFloorPlan
    const hotspotObjects = sceneTitle
      .filter((scene) => scene.coordinates && scene.coordinates.length === 2)
      .map((scene) => ({
        id: scene.sceneId,
        title: scene.title,
        coordinates: scene.coordinates,
        type: 'Scene',
      }));

    const amenitiesMap = {
      image: {
        url: AMENITIES_IMAGE_URL,
        name: 'Amenities',
      },
      objects: hotspotObjects,
    };

    if (existingIndex >= 0) {
      const hs = hotspotList[existingIndex];
      hs.mapFloorPlan = [amenitiesMap];
      // Move this hotspot to the front so the amenities map is prioritized
      hotspotList.splice(existingIndex, 1);
      hotspotList.unshift(hs);
    } else {
      const newHotspot = {
        id: `override-mapfloorplan-${scene._id || scene.id}`,
        type: 'MapFloorPlan',
        distance: '0',
        location: [0, 0, 0],
        mediaLinkId: null,
        tourLinkedId: null,
        sceneLinkId: null,
        sceneVariantId: null,
        icon: null,
        iconUrl: null,
        iconActiveUrl: null,
        polygon: [],
        configs: '',
        mapFloorPlan: [amenitiesMap],
      };
      // Ensure hotspots array exists and insert at the beginning
      scene.hotspots = hotspotList;
      scene.hotspots.unshift(newHotspot);
    }
  };

  const outdoorIds = new Set(outDoorJumpSpots);
  const flycamIds = new Set(sceneFlycamOutdoorSpots);
  const apartmentIds = new Set(apartmentSpots);
  const titleMap = new Map(
    sceneTitle.map((item) => [item.sceneId, item.title])
  );
  const amenitiesSceneIds = new Set(amenitiesScenes);
  const inDoorJumpSceneIds = new Set(inDoorJumpSpots);
  json.scenes.forEach((scene) => {
    if (outdoorIds.has(scene._id)) {
      scene.outdoorScene = true;
    }
    if (flycamIds.has(scene._id)) {
      scene.flycamOutdoorScene = true;
    }
    if (apartmentIds.has(scene._id)) {
      scene.apartmentScene = true;
    }
    if (titleMap.has(scene._id)) {
      scene.title = titleMap.get(scene._id);
    }
    if (inDoorJumpSceneIds.has(scene._id)) {
      scene.indoorScene = true;
    } 
    if (amenitiesSceneIds.has(scene._id)) {
      scene.amenitiesScene = true;
    }

    //override scene type
    // if (scene?._id === '68d12cca208f82c724e17eb7') {
    //   scene.cubeMapImages.size1024[4] =
    //     '/assets/override-images/opt1/1024-pz.webp';
    //   scene.cubeMapImages.size2048[4] =
    //     '/assets/override-images/opt1/2048-pz.webp';
    //   scene.cubeMapImages.size4096[4] =
    //     '/assets/override-images/opt1/4096-pz.webp';
    // }

    if (scene?._id === '68d12e81208f82c724e18004') {
      scene.cubeMapImages.size1024[0] =
        '/assets/override-images/opt2/1024-px.webp';
      scene.cubeMapImages.size2048[0] =
        '/assets/override-images/opt2/2048-px.webp';
      scene.cubeMapImages.size4096[0] =
        '/assets/override-images/opt2/4096-px.webp';
    }

    // Apply amenities map for all scenes
    upsertAmenitiesFloorPlanHotspot(scene);
  });

  if (Array.isArray(json.menu)) {
    json.menu.forEach((menuGroup) => {
      if (Array.isArray(menuGroup.scenes)) {
        menuGroup.scenes.forEach((menuScene) => {
          if (apartmentIds.has(menuScene._id)) {
            menuScene.apartmentScene = true;
          }
          if (titleMap.has(menuScene._id)) {
            menuScene.title = titleMap.get(menuScene._id);
          }
        });
      }
    });
  }
};

export default applyOverrideData;
